import { defaultStyles } from 'library';
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    inputWrapper: {
        display: 'inline-block',
        width: '100%',
        maxWidth: '320px',
        textAlign: 'right',
        margin: '.8rem 0',
        '@media print, screen and (min-width: 700px)': {
            textAlign: 'inherit',
        },
        '@media print': {
            display: 'none',
        }
    },
    inputContainer: {
        '@media print': {
            display: 'inline-block',
            textAlign: 'right'
        }
    },
    inputLabel: {
        textAlign: 'left',
        fontWeight: 'bold',
        marginBottom: '.5rem',
        '@media print': {
            marginLeft: '16px',
            display: 'none'
        }
    },
    labelPrintable: {
        display: 'none',
        '@media print': {
            display: 'block',
            marginLeft: '0',
        }
    },
    labelNotPrintable: {
        display: 'block',

    },
    inputBlock: {
        display: 'table',
        width: '100%',
        marginBottom: '.5rem',
        '@media print': {
            display: 'inline-block',
            textAlign: 'left',
            marginLeft: '32px',
        }
    },

    inputStyle: {
        backgroundColor: '#FFF',
        borderStyle: 'solid',
        borderWidth: '2px',
        borderColor: '#d3d3d3',
        borderRadius: '5px',
        color: '#001120',
        fontSize: '.875rem',
        height: '2.3125rem',
        lineHeight: '24px',
        margin: '0',
        padding: '.5rem',
        display: 'table-cell',
        width: '100%',
        '@media print, screen and (min-width: 700px)': {
            //width: '120px',
        },
        ':disabled': {
            cursor: 'not-allowed',
            backgroundColor: defaultStyles.lightGrey
        }
    },

    inputOperator: {
        fontWeight: 'bold',
        fontSize: '20px',
        color: defaultStyles.blue,
        display: 'table-cell',
        padding: '0.5rem',
        width: '40px;',
        transform: 'translateY(44px)',
    },

    inputUnit: {
        fontWeight: 'bold',
        fontSize: '20px',
        color: defaultStyles.blue,
        display: 'table-cell',
        transform: 'translateY(44px)',
        padding: '0.5rem',
        width: '54px;',
        textAlign: 'left',
        '@media print': {
            display: 'inline-block',
            fontSize: '2rem',
            transform: 'none',
        }
    },
    inputDescription: {
        textAlign: 'left',
        fontStyle: 'italic',
        fontSize: '14px',
        lineHeight: '24px',
        marginBottom: '.5rem',
        '@media print, screen and (min-width: 700px)': {
            padding: '.5rem 0',
        },
    },
    inputError: {
        borderColor: defaultStyles.red,
    },
    labelError: {
        color: defaultStyles.red,
    },
    printable: {
        '@media print': {
            display: 'inline-block',
        }
    },
    hideForPrint: {
        '@media print': {
            display: 'none',
        }
    },
    showForPrint: {
        display: 'none',
        '@media print': {
            display: 'inline-block',
            color: '#001120',
            fontSize: '2rem',
        }
    },
    inputForPrint: {
        '@media print': {
            display: 'none',
            width: '150px',
            textAlign: 'right',
            backgroundColor: 'transparent',
            borderStyle: 'none',
            borderWidth: '0px',
            borderColor: 'transparent',
            boxShadow: 'none',
            height: 'auto',
            margin: '0',
            padding: '0',
        }
    }
});

export default styles;